/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssignBusinessGroupDto } from '../models';
// @ts-ignore
import { AssignBusinessGroupToOperatorGroup200Response } from '../models';
// @ts-ignore
import { AssignBusinessGroupToOperatorGroupDto } from '../models';
// @ts-ignore
import { AssignBusinessGroupToOperatorUser200Response } from '../models';
// @ts-ignore
import { BusinessGroupRoleEntity } from '../models';
// @ts-ignore
import { CreateOperatorGroupDto } from '../models';
// @ts-ignore
import { CreateOperatorUserDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { OperatorGroupEntity } from '../models';
// @ts-ignore
import { OperatorUserEntity } from '../models';
// @ts-ignore
import { UpdateOperatorGroupDto } from '../models';
// @ts-ignore
import { UpdateOperatorUserDto } from '../models';
/**
 * OperatorRolesApi - axios parameter creator
 * @export
 */
export const OperatorRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign a business group to operator groups
         * @param {AssignBusinessGroupToOperatorGroupDto} assignBusinessGroupToOperatorGroupDto Payload for assigning a business group to operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBusinessGroupToOperatorGroup: async (assignBusinessGroupToOperatorGroupDto: AssignBusinessGroupToOperatorGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignBusinessGroupToOperatorGroupDto' is not null or undefined
            assertParamExists('assignBusinessGroupToOperatorGroup', 'assignBusinessGroupToOperatorGroupDto', assignBusinessGroupToOperatorGroupDto)
            const localVarPath = `/api/v1.0/roles/assign-business-group-to-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignBusinessGroupToOperatorGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign a business group to operator users
         * @param {AssignBusinessGroupDto} assignBusinessGroupDto Payload for assigning a business group to operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBusinessGroupToOperatorUser: async (assignBusinessGroupDto: AssignBusinessGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignBusinessGroupDto' is not null or undefined
            assertParamExists('assignBusinessGroupToOperatorUser', 'assignBusinessGroupDto', assignBusinessGroupDto)
            const localVarPath = `/api/v1.0/roles/assign-business-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignBusinessGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new operator group
         * @param {CreateOperatorGroupDto} createOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAOperatorGroup: async (createOperatorGroupDto: CreateOperatorGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOperatorGroupDto' is not null or undefined
            assertParamExists('createAOperatorGroup', 'createOperatorGroupDto', createOperatorGroupDto)
            const localVarPath = `/api/v1.0/roles/create-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperatorGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new operator user
         * @param {CreateOperatorUserDto} createOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAOperatorUser: async (createOperatorUserDto: CreateOperatorUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOperatorUserDto' is not null or undefined
            assertParamExists('createAOperatorUser', 'createOperatorUserDto', createOperatorUserDto)
            const localVarPath = `/api/v1.0/roles/create-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperatorUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows creating up to 1000 operator users in a single request.
         * @summary Create multiple operator users
         * @param {Array<CreateOperatorUserDto>} createOperatorUserDto Array of operator users to create. Maximum allowed users per bulk upload is 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkOperatorUsers: async (createOperatorUserDto: Array<CreateOperatorUserDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOperatorUserDto' is not null or undefined
            assertParamExists('createBulkOperatorUsers', 'createOperatorUserDto', createOperatorUserDto)
            const localVarPath = `/api/v1.0/roles/bulk-create-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOperatorUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete operator group by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorGroupById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOperatorGroupById', 'id', id)
            const localVarPath = `/api/v1.0/roles/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorGroupByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteOperatorGroupByName', 'name', name)
            const localVarPath = `/api/v1.0/roles/group/name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorUserByEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('deleteOperatorUserByEmail', 'email', email)
            const localVarPath = `/api/v1.0/roles/user/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorUserById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOperatorUserById', 'id', id)
            const localVarPath = `/api/v1.0/roles/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOperatorGroups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/roles/all-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOperatorUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/roles/all-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorGroupByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getOperatorGroupByName', 'name', name)
            const localVarPath = `/api/v1.0/roles/group/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorUserByEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getOperatorUserByEmail', 'email', email)
            const localVarPath = `/api/v1.0/roles/user/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorUserById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOperatorUserById', 'id', id)
            const localVarPath = `/api/v1.0/roles/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get roles and business groups for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesByUserId: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing operator group
         * @param {string} id 
         * @param {UpdateOperatorGroupDto} updateOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorGroup: async (id: string, updateOperatorGroupDto: UpdateOperatorGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOperatorGroup', 'id', id)
            // verify required parameter 'updateOperatorGroupDto' is not null or undefined
            assertParamExists('updateOperatorGroup', 'updateOperatorGroupDto', updateOperatorGroupDto)
            const localVarPath = `/api/v1.0/roles/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperatorGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing operator user
         * @param {string} id 
         * @param {UpdateOperatorUserDto} updateOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorUser: async (id: string, updateOperatorUserDto: UpdateOperatorUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOperatorUser', 'id', id)
            // verify required parameter 'updateOperatorUserDto' is not null or undefined
            assertParamExists('updateOperatorUser', 'updateOperatorUserDto', updateOperatorUserDto)
            const localVarPath = `/api/v1.0/roles/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOperatorUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperatorRolesApi - functional programming interface
 * @export
 */
export const OperatorRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperatorRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign a business group to operator groups
         * @param {AssignBusinessGroupToOperatorGroupDto} assignBusinessGroupToOperatorGroupDto Payload for assigning a business group to operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignBusinessGroupToOperatorGroup(assignBusinessGroupToOperatorGroupDto: AssignBusinessGroupToOperatorGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignBusinessGroupToOperatorGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignBusinessGroupToOperatorGroup(assignBusinessGroupToOperatorGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Assign a business group to operator users
         * @param {AssignBusinessGroupDto} assignBusinessGroupDto Payload for assigning a business group to operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignBusinessGroupToOperatorUser(assignBusinessGroupDto: AssignBusinessGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignBusinessGroupToOperatorUser200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignBusinessGroupToOperatorUser(assignBusinessGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new operator group
         * @param {CreateOperatorGroupDto} createOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAOperatorGroup(createOperatorGroupDto: CreateOperatorGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAOperatorGroup(createOperatorGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new operator user
         * @param {CreateOperatorUserDto} createOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAOperatorUser(createOperatorUserDto: CreateOperatorUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAOperatorUser(createOperatorUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows creating up to 1000 operator users in a single request.
         * @summary Create multiple operator users
         * @param {Array<CreateOperatorUserDto>} createOperatorUserDto Array of operator users to create. Maximum allowed users per bulk upload is 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkOperatorUsers(createOperatorUserDto: Array<CreateOperatorUserDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkOperatorUsers(createOperatorUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete operator group by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperatorGroupById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorGroupEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperatorGroupById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperatorGroupByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorGroupEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperatorGroupByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperatorUserByEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperatorUserByEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperatorUserById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperatorUserById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOperatorGroups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperatorGroupEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOperatorGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOperatorUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperatorUserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOperatorUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorGroupByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorGroupEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorGroupByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorUserByEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorUserByEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperatorUserById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperatorUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperatorUserById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get roles and business groups for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRolesByUserId(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessGroupRoleEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRolesByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing operator group
         * @param {string} id 
         * @param {UpdateOperatorGroupDto} updateOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperatorGroup(id: string, updateOperatorGroupDto: UpdateOperatorGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperatorGroup(id, updateOperatorGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing operator user
         * @param {string} id 
         * @param {UpdateOperatorUserDto} updateOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperatorUser(id: string, updateOperatorUserDto: UpdateOperatorUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperatorUser(id, updateOperatorUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperatorRolesApi - factory interface
 * @export
 */
export const OperatorRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperatorRolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign a business group to operator groups
         * @param {AssignBusinessGroupToOperatorGroupDto} assignBusinessGroupToOperatorGroupDto Payload for assigning a business group to operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBusinessGroupToOperatorGroup(assignBusinessGroupToOperatorGroupDto: AssignBusinessGroupToOperatorGroupDto, options?: any): AxiosPromise<AssignBusinessGroupToOperatorGroup200Response> {
            return localVarFp.assignBusinessGroupToOperatorGroup(assignBusinessGroupToOperatorGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign a business group to operator users
         * @param {AssignBusinessGroupDto} assignBusinessGroupDto Payload for assigning a business group to operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignBusinessGroupToOperatorUser(assignBusinessGroupDto: AssignBusinessGroupDto, options?: any): AxiosPromise<AssignBusinessGroupToOperatorUser200Response> {
            return localVarFp.assignBusinessGroupToOperatorUser(assignBusinessGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new operator group
         * @param {CreateOperatorGroupDto} createOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAOperatorGroup(createOperatorGroupDto: CreateOperatorGroupDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAOperatorGroup(createOperatorGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new operator user
         * @param {CreateOperatorUserDto} createOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAOperatorUser(createOperatorUserDto: CreateOperatorUserDto, options?: any): AxiosPromise<OperatorUserEntity> {
            return localVarFp.createAOperatorUser(createOperatorUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows creating up to 1000 operator users in a single request.
         * @summary Create multiple operator users
         * @param {Array<CreateOperatorUserDto>} createOperatorUserDto Array of operator users to create. Maximum allowed users per bulk upload is 1000.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkOperatorUsers(createOperatorUserDto: Array<CreateOperatorUserDto>, options?: any): AxiosPromise<void> {
            return localVarFp.createBulkOperatorUsers(createOperatorUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete operator group by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorGroupById(id: string, options?: any): AxiosPromise<OperatorGroupEntity> {
            return localVarFp.deleteOperatorGroupById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorGroupByName(name: string, options?: any): AxiosPromise<OperatorGroupEntity> {
            return localVarFp.deleteOperatorGroupByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorUserByEmail(email: string, options?: any): AxiosPromise<OperatorUserEntity> {
            return localVarFp.deleteOperatorUserByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperatorUserById(id: string, options?: any): AxiosPromise<OperatorUserEntity> {
            return localVarFp.deleteOperatorUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all operator groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOperatorGroups(options?: any): AxiosPromise<Array<OperatorGroupEntity>> {
            return localVarFp.getAllOperatorGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all operator users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOperatorUsers(options?: any): AxiosPromise<Array<OperatorUserEntity>> {
            return localVarFp.getAllOperatorUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get operator group by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorGroupByName(name: string, options?: any): AxiosPromise<OperatorGroupEntity> {
            return localVarFp.getOperatorGroupByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get operator user by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorUserByEmail(email: string, options?: any): AxiosPromise<OperatorUserEntity> {
            return localVarFp.getOperatorUserByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get operator user by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperatorUserById(id: string, options?: any): AxiosPromise<OperatorUserEntity> {
            return localVarFp.getOperatorUserById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get roles and business groups for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRolesByUserId(options?: any): AxiosPromise<Array<BusinessGroupRoleEntity>> {
            return localVarFp.getRolesByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing operator group
         * @param {string} id 
         * @param {UpdateOperatorGroupDto} updateOperatorGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorGroup(id: string, updateOperatorGroupDto: UpdateOperatorGroupDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateOperatorGroup(id, updateOperatorGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing operator user
         * @param {string} id 
         * @param {UpdateOperatorUserDto} updateOperatorUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperatorUser(id: string, updateOperatorUserDto: UpdateOperatorUserDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateOperatorUser(id, updateOperatorUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignBusinessGroupToOperatorGroup operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiAssignBusinessGroupToOperatorGroupRequest
 */
export interface OperatorRolesApiAssignBusinessGroupToOperatorGroupRequest {
    /**
     * Payload for assigning a business group to operator groups
     * @type {AssignBusinessGroupToOperatorGroupDto}
     * @memberof OperatorRolesApiAssignBusinessGroupToOperatorGroup
     */
    readonly assignBusinessGroupToOperatorGroupDto: AssignBusinessGroupToOperatorGroupDto
}

/**
 * Request parameters for assignBusinessGroupToOperatorUser operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiAssignBusinessGroupToOperatorUserRequest
 */
export interface OperatorRolesApiAssignBusinessGroupToOperatorUserRequest {
    /**
     * Payload for assigning a business group to operator users
     * @type {AssignBusinessGroupDto}
     * @memberof OperatorRolesApiAssignBusinessGroupToOperatorUser
     */
    readonly assignBusinessGroupDto: AssignBusinessGroupDto
}

/**
 * Request parameters for createAOperatorGroup operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiCreateAOperatorGroupRequest
 */
export interface OperatorRolesApiCreateAOperatorGroupRequest {
    /**
     * 
     * @type {CreateOperatorGroupDto}
     * @memberof OperatorRolesApiCreateAOperatorGroup
     */
    readonly createOperatorGroupDto: CreateOperatorGroupDto
}

/**
 * Request parameters for createAOperatorUser operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiCreateAOperatorUserRequest
 */
export interface OperatorRolesApiCreateAOperatorUserRequest {
    /**
     * 
     * @type {CreateOperatorUserDto}
     * @memberof OperatorRolesApiCreateAOperatorUser
     */
    readonly createOperatorUserDto: CreateOperatorUserDto
}

/**
 * Request parameters for createBulkOperatorUsers operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiCreateBulkOperatorUsersRequest
 */
export interface OperatorRolesApiCreateBulkOperatorUsersRequest {
    /**
     * Array of operator users to create. Maximum allowed users per bulk upload is 1000.
     * @type {Array<CreateOperatorUserDto>}
     * @memberof OperatorRolesApiCreateBulkOperatorUsers
     */
    readonly createOperatorUserDto: Array<CreateOperatorUserDto>
}

/**
 * Request parameters for deleteOperatorGroupById operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiDeleteOperatorGroupByIdRequest
 */
export interface OperatorRolesApiDeleteOperatorGroupByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiDeleteOperatorGroupById
     */
    readonly id: string
}

/**
 * Request parameters for deleteOperatorGroupByName operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiDeleteOperatorGroupByNameRequest
 */
export interface OperatorRolesApiDeleteOperatorGroupByNameRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiDeleteOperatorGroupByName
     */
    readonly name: string
}

/**
 * Request parameters for deleteOperatorUserByEmail operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiDeleteOperatorUserByEmailRequest
 */
export interface OperatorRolesApiDeleteOperatorUserByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiDeleteOperatorUserByEmail
     */
    readonly email: string
}

/**
 * Request parameters for deleteOperatorUserById operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiDeleteOperatorUserByIdRequest
 */
export interface OperatorRolesApiDeleteOperatorUserByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiDeleteOperatorUserById
     */
    readonly id: string
}

/**
 * Request parameters for getOperatorGroupByName operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiGetOperatorGroupByNameRequest
 */
export interface OperatorRolesApiGetOperatorGroupByNameRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiGetOperatorGroupByName
     */
    readonly name: string
}

/**
 * Request parameters for getOperatorUserByEmail operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiGetOperatorUserByEmailRequest
 */
export interface OperatorRolesApiGetOperatorUserByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiGetOperatorUserByEmail
     */
    readonly email: string
}

/**
 * Request parameters for getOperatorUserById operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiGetOperatorUserByIdRequest
 */
export interface OperatorRolesApiGetOperatorUserByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiGetOperatorUserById
     */
    readonly id: string
}

/**
 * Request parameters for updateOperatorGroup operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiUpdateOperatorGroupRequest
 */
export interface OperatorRolesApiUpdateOperatorGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiUpdateOperatorGroup
     */
    readonly id: string

    /**
     * 
     * @type {UpdateOperatorGroupDto}
     * @memberof OperatorRolesApiUpdateOperatorGroup
     */
    readonly updateOperatorGroupDto: UpdateOperatorGroupDto
}

/**
 * Request parameters for updateOperatorUser operation in OperatorRolesApi.
 * @export
 * @interface OperatorRolesApiUpdateOperatorUserRequest
 */
export interface OperatorRolesApiUpdateOperatorUserRequest {
    /**
     * 
     * @type {string}
     * @memberof OperatorRolesApiUpdateOperatorUser
     */
    readonly id: string

    /**
     * 
     * @type {UpdateOperatorUserDto}
     * @memberof OperatorRolesApiUpdateOperatorUser
     */
    readonly updateOperatorUserDto: UpdateOperatorUserDto
}

/**
 * OperatorRolesApi - object-oriented interface
 * @export
 * @class OperatorRolesApi
 * @extends {BaseAPI}
 */
export class OperatorRolesApi extends BaseAPI {
    /**
     * 
     * @summary Assign a business group to operator groups
     * @param {OperatorRolesApiAssignBusinessGroupToOperatorGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public assignBusinessGroupToOperatorGroup(requestParameters: OperatorRolesApiAssignBusinessGroupToOperatorGroupRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).assignBusinessGroupToOperatorGroup(requestParameters.assignBusinessGroupToOperatorGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign a business group to operator users
     * @param {OperatorRolesApiAssignBusinessGroupToOperatorUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public assignBusinessGroupToOperatorUser(requestParameters: OperatorRolesApiAssignBusinessGroupToOperatorUserRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).assignBusinessGroupToOperatorUser(requestParameters.assignBusinessGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new operator group
     * @param {OperatorRolesApiCreateAOperatorGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public createAOperatorGroup(requestParameters: OperatorRolesApiCreateAOperatorGroupRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).createAOperatorGroup(requestParameters.createOperatorGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new operator user
     * @param {OperatorRolesApiCreateAOperatorUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public createAOperatorUser(requestParameters: OperatorRolesApiCreateAOperatorUserRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).createAOperatorUser(requestParameters.createOperatorUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows creating up to 1000 operator users in a single request.
     * @summary Create multiple operator users
     * @param {OperatorRolesApiCreateBulkOperatorUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public createBulkOperatorUsers(requestParameters: OperatorRolesApiCreateBulkOperatorUsersRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).createBulkOperatorUsers(requestParameters.createOperatorUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete operator group by ID
     * @param {OperatorRolesApiDeleteOperatorGroupByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public deleteOperatorGroupById(requestParameters: OperatorRolesApiDeleteOperatorGroupByIdRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).deleteOperatorGroupById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete operator group by name
     * @param {OperatorRolesApiDeleteOperatorGroupByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public deleteOperatorGroupByName(requestParameters: OperatorRolesApiDeleteOperatorGroupByNameRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).deleteOperatorGroupByName(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete operator user by email
     * @param {OperatorRolesApiDeleteOperatorUserByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public deleteOperatorUserByEmail(requestParameters: OperatorRolesApiDeleteOperatorUserByEmailRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).deleteOperatorUserByEmail(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete operator user by ID
     * @param {OperatorRolesApiDeleteOperatorUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public deleteOperatorUserById(requestParameters: OperatorRolesApiDeleteOperatorUserByIdRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).deleteOperatorUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all operator groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getAllOperatorGroups(options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getAllOperatorGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all operator users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getAllOperatorUsers(options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getAllOperatorUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get operator group by name
     * @param {OperatorRolesApiGetOperatorGroupByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getOperatorGroupByName(requestParameters: OperatorRolesApiGetOperatorGroupByNameRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getOperatorGroupByName(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get operator user by email
     * @param {OperatorRolesApiGetOperatorUserByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getOperatorUserByEmail(requestParameters: OperatorRolesApiGetOperatorUserByEmailRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getOperatorUserByEmail(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get operator user by ID
     * @param {OperatorRolesApiGetOperatorUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getOperatorUserById(requestParameters: OperatorRolesApiGetOperatorUserByIdRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getOperatorUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get roles and business groups for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public getRolesByUserId(options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).getRolesByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing operator group
     * @param {OperatorRolesApiUpdateOperatorGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public updateOperatorGroup(requestParameters: OperatorRolesApiUpdateOperatorGroupRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).updateOperatorGroup(requestParameters.id, requestParameters.updateOperatorGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing operator user
     * @param {OperatorRolesApiUpdateOperatorUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperatorRolesApi
     */
    public updateOperatorUser(requestParameters: OperatorRolesApiUpdateOperatorUserRequest, options?: AxiosRequestConfig) {
        return OperatorRolesApiFp(this.configuration).updateOperatorUser(requestParameters.id, requestParameters.updateOperatorUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}
